// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1q1U_","left":"styles_left__3r09a"};